function matchProjectsMapHeight() {
    const projects = document.querySelector('.b-projects.layout-1');
    if (!projects) return;

    const content = document.querySelector('.b-projects__content');

    const targetSelectors = [
        '.b-projects__map',
        '#geodir_map',
        '.geodir-map-container',
        '.geodir-wgt-map',
        '.geodir-map-wrap',
        '.stick_trigger_container',
        '.geodir_map_container',
        '.map_background',
        '#gd_map_canvas_directory',
        '#gd_map_canvas_directory_wrapper',
        '.top_banner_section_in',
    ];

    const projectsHeight = content.offsetHeight;

    targetSelectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
            el.style.height = `${projectsHeight}px`;
        });
    });
}

  // Run on DOM load
// document.addEventListener('DOMContentLoaded', () => {
    matchProjectsMapHeight();
    window.addEventListener('resize', matchProjectsMapHeight);
// });
